class ThumbnailCarouselVertical {
  constructor () {
    this.carouselVertical = document.querySelector('[data-thumbnail-carousel-vertical]')
    this.carouselNavPrev = this.carouselVertical.querySelector('[data-thumbnail-nav-previous]')
    this.carouselNavNext = this.carouselVertical.querySelector('[data-thumbnail-nav-next]')
    this.carouselTrack = this.carouselVertical.querySelector('#vertical-thumbnail-carousel-track')

    this.setInitialState()
    this.carouselNavPrev.addEventListener('click', () => this.toPrev())
    this.carouselNavNext.addEventListener('click', () => this.toNext())
    this.updateNavVisibility()
    this.hideOnImgError()
    this.lazyLoadImages()
  }

  setInitialState () {
    this.allThumbnails = this.carouselVertical.querySelectorAll('[data-thumbnail-item]')
    this.totalThumbnails = this.allThumbnails.length
    this.slideStepsAllowed = this.totalThumbnails - 5
    this.slideStepsRemainingDown = this.slideStepsAllowed
    this.slideStepsRemainingUp = 0
    this.slideDistance = 0
  }

  updateNavVisibility () {
    if (this.totalThumbnails <= 5) {
      this.carouselNavPrev.style.display = 'none'
      this.carouselNavNext.style.display = 'none'
      return
    }

    if (this.slideStepsRemainingUp === 0) {
      this.carouselNavPrev.style.display = 'none'
    } else {
      this.carouselNavPrev.style.display = 'flex'
    }

    if (this.slideStepsRemainingDown === 0) {
      this.carouselNavNext.style.display = 'none'
    } else {
      this.carouselNavNext.style.display = 'flex'
    }
  }

  toPrev () {
    if (this.slideStepsRemainingUp > 0) {
      this.slideStepsRemainingUp -= 1
      this.slideStepsRemainingDown += 1
      this.slideDistance += 20
      this.carouselTrack.style.transform = `translateY(${this.slideDistance}%)`
    }
    this.updateNavVisibility()
  }

  toNext () {
    if (this.slideStepsRemainingDown > 0) {
      this.slideStepsRemainingDown -= 1
      this.slideStepsRemainingUp += 1
      this.slideDistance -= 20
      this.carouselTrack.style.transform = `translateY(${this.slideDistance}%)`
    }
    this.updateNavVisibility()
  }

  lazyLoadImages () {
    const observer = new IntersectionObserver(function (entries, self) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const image = entry.target.querySelector('img')
          image.src = image.getAttribute('data-src')
          self.unobserve(entry.target)
        }
      })
    })

    this.allThumbnails.forEach(thumb => {
      observer.observe(thumb)
    })
  }

  hideOnImgError () {
    document.addEventListener('error', (e) => {
      if ((e.target.tagName.toLowerCase() === 'img') && e.target.closest('[data-thumbnail-item]')) {
        e.target.closest('[data-thumbnail-item]').remove()
        this.setInitialState()
        this.updateNavVisibility()

        // reset indexes to open the correct gallery slide
        this.allThumbnails.forEach((thumb, index) => {
          thumb.setAttribute('data-gallery-starting-index', index)
        })
      }
    }, true)
  }
}

export function initVerticalCarousel () {
  if (!document.getElementById('vertical-thumbnail-carousel-track')) {
    return false
  }
  return new ThumbnailCarouselVertical()
}

document.addEventListener('DOMContentLoaded', initVerticalCarousel)
